export default "__VITE_ASSET__CqloQi9n__"